import { render, staticRenderFns } from "./inviteList.vue?vue&type=template&id=2d46f210&scoped=true"
import script from "./inviteList.vue?vue&type=script&lang=js"
export * from "./inviteList.vue?vue&type=script&lang=js"
import style0 from "../index.css?vue&type=style&index=0&id=2d46f210&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@4.47.0_supports-_afcd48d4a41aa41dd7c763bb85ff8663/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46f210",
  null
  
)

export default component.exports